/**
 * OmmnioSign document formats shown in the chat acknowledge drawer must not require
 * routing flows that only work in the bulk send wizard (code/DNI PDF extraction, etc.).
 *
 * @param {object} format – DocumentFormat from API
 * @param {{ isDirectChannel?: boolean }} [opts]
 * @returns {boolean}
 */
export default function filterDocumentFormatsForChatComposer(format, opts = {}) {
  const { isDirectChannel = false } = opts;
  const items = format.items || [];
  const signingMode = format.signingMode || 'onePerMember';

  // B7: cannot combine oneForAll with PDF routing items
  if (items.length > 0 && signingMode === 'oneForAll') {
    return false;
  }

  // B7: reject templates that resolve recipients or file names via PDF extraction regions
  const hasDisallowedRoutingBox = items.some(
    i => i.selector === 'box' && ['code', 'id', 'dni', 'year', 'month', 'day'].includes(i.name),
  );
  if (hasDisallowedRoutingBox) {
    return false;
  }

  // B8: 1:1 chat cannot host collective signing that requires more than two signer slots
  if (isDirectChannel && signingMode === 'oneForAll') {
    const slots = requiredSignerSlotsFromTemplate(format);
    if (slots > 2) {
      return false;
    }
  }

  return true;
}

function requiredSignerSlotsFromTemplate(format) {
  const sigs = (format.fields || []).filter(f => f.type === 'signature');
  if (!sigs.length) {
    return 0;
  }
  return Math.max(...sigs.map(f => f.signerIndex ?? 0)) + 1;
}
